
/**
 * Special component for Romanza default section.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 2.0.0
 * @copyright  Copyright (C) 2021-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2021-12-23 (1.0.0) (jhoward)
 *      - Default layout for Romanza menu section.
 *
 *    2022-03-04 (1.0.1) (jhoward)
 *      - Fixed tag title, they are now dynamic.
 *
 *    2022-03-10 (1.1.0) (jhoward)
 *      - Refactor tags to use <menu-tag /> component.
 *      - Add <menu-tag-legend />.
 *
 *    2022-03-31 (1.1.1) (jhoward)
 *      - Add menu version number to Romanza_defaultSection.vue.
 *
 *    2022-04-21 (1.2.0) (jhoward)
 *      - Add menu item grouping to Romanza_defaultSection.vue.
 *      - Compute this.items in Romanza_defaultSection.vue.
 *
 *    2023-04-17 (1.2.0) (jhoward)
 *      - Refactor <Romanza_defaultSection> to use TypeScript.
 *      - <Romanza_defaultSection> section prop is required.
 *      - Refactor <Romanza_defaultSection> to use helper functions for computed properties.
 *
 *    2023-08-23 (1.3.0) (jhoward)
 *      - Use <menu-version> in <Romanza_defaultSection>.
 *
 *    2023-11-08 (1.3.1) (jhoward)
 *      - Move <menu-tag> to the left of titles in <Romanza_defaultSection>.
 *      - Allow HTML in item.mi_description in <Romanza_defaultSection>.
 *
 *    2024-07-19 (1.3.2) (jhoward)
 *      - Rename .visual_menu--tag CSS rules to .menu--tag in <romanza-default-section>.
 *
 *    2025-02-10 (1.4.0) (jhoward)
 *      - Add <menu-schedules> to the <Romanza_defaultSection> component if in admin view.
 *
 *  2025-04-08 (2.0.0) (jhoward)
 *    - Use <default-textual-section> and <default-visual-section> in <Romanza_defaultSection>.
 */

import {defineComponent, PropType} from "vue";
import {ALLOWED_ITEM_COMPONENTS, Menu, MENU_ITEM_TAG_LOCATIONS, MenuSection} from "../defs";
import DefaultVisualSection from "./visual/defaultVisualSection.vue";
import DefaultTextualSection from "./textual/defaultTextualSection.vue";
import MenuItemGroup from "../menu-item-group.vue";

export default defineComponent({
  components: {
    MenuItemGroup,
    DefaultTextualSection, DefaultVisualSection,
  },
  name: "Romanza_defaultSection",
  props: {
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    menu: {
      type: Object as PropType<Menu>,
      required: true
    },
    menuItemComponent: {
      type: String,
      default: '',
      validate: (value: string) => '' === value || ALLOWED_ITEM_COMPONENTS.indexOf(value)
    },
    menuItemTagLocation: {
      type: String as PropType<MENU_ITEM_TAG_LOCATIONS>,
      default: 'before-title'
    },
  },
})
